import { render, staticRenderFns } from "./shop.add.vue?vue&type=template&id=4817e5ce&scoped=true"
import script from "./shop.add.vue?vue&type=script&lang=js"
export * from "./shop.add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4817e5ce",
  null
  
)

export default component.exports